import styled, { css } from 'styled-components';

import { primitive } from 'styles/constants/primitives';
import { fadeIn } from 'utils/style/animations';

export const ImageWrapper = styled.div`
  position: relative;
  width: 9.375rem;
  height: 6.25rem;
  flex-shrink: 0;
  z-index: ${Styles.zIndex.below};
  ${Styles.mobileTiny} {
    width: 7rem;
  }
`;

export const StyledClickableContainer = styled.button<{
  isLocked: boolean;
}>`
  /* reset button styles */
  border: none;
  text-align: start;
  background: ${primitive.$white};
  display: flex;

  width: 100%;
  height: 100%;
  opacity: 0;
  animation: ${fadeIn} 0.4s forwards;
  border-block-end: 1px solid ${Styles.color.grey.four};
  padding: 1rem;
  cursor: pointer;
  position: relative;
  z-index: ${Styles.zIndex.normal};

  ${ImageWrapper} {
    img {
      ${p =>
        p.isLocked &&
        css`
          opacity: 0.5;
        `}
    }
  }
`;

export const ExternalIncentiveCardDescription = styled.p`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  max-height: 2rem;
  margin: 0;
`;
